module.exports = __webpack_public_path__ + "static/media/flyermechanicFaicoMobile.18024ec9.png";